import { toast } from "react-toastify"

const Toast = (message: string, type: string): any => {
  switch (type) {
    case "success":
      return toast.success(
        <div style={{ fontSize: '14px' }}>
          {message}
        </div>,
        {
          autoClose: 6000
        }
      )
    case "error":
      return toast.error(
        <div style={{ fontSize: '14px' }}>
          {message}
        </div>,
        {
          autoClose: 6000
        }
      )
    case "warning":
      return toast.warning(
        <div style={{ fontSize: '14px' }}>
          {message}
        </div>,
        {
          autoClose: 6000
        }
      )
    default:
      return toast.warning(
        <div style={{ fontSize: '14px' }}>
          {message}
        </div>
      )
  }
}
export default Toast
